module.exports = __webpack_public_path__ + "img/icon_guanyuwomen_fengxian@3x.3137de75.png";